"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPoisFromCache = exports.getNameDenylistFromCache = exports.getCatalystServersFromCache = void 0;
const data_1 = require("./data");
function getCatalystServersFromCache(network) {
    return data_1.cache.catalysts[network];
}
exports.getCatalystServersFromCache = getCatalystServersFromCache;
function getNameDenylistFromCache(network) {
    return data_1.cache.nameDenylist[network];
}
exports.getNameDenylistFromCache = getNameDenylistFromCache;
function getPoisFromCache(network) {
    return data_1.cache.pois[network];
}
exports.getPoisFromCache = getPoisFromCache;
//# sourceMappingURL=index.js.map